import React from 'react';
import PropTypes from 'prop-types';

import { Table, Column, SortIndicator } from 'react-virtualized';
import { LinkButton } from 'shared/Buttons';

const DownloadsTable = ({ data, registerChild, nameRenderer, dateRenderer, ...rest }) => {
  const rowGetter = ({ index }) => {
    return data[index] || {};
  };

  const tableProps = {
    ...rest,
    headerHeight: 55,
    rowHeight: 55,
    rowGetter,
    rowClassName: 'table-row',
    headerClassName: 'table-header',
    girdClassName: 'table__visible-items',
    scrollToAlignment: 'start'
  };

  const headerRenderer = ({ label, dataKey, sortBy, sortDirection }) => (
    <div>
      {label}
      {sortBy === dataKey && <SortIndicator {...{ sortDirection }} />}
    </div>
  );

  const productRenderer = ({ rowData }) => {
    const { productId, productName } = rowData;
    return !productId ? (
      productName
    ) : (
      <LinkButton to={`/products/${productId}`}>{productName}</LinkButton>
    );
  };

  return (
    <Table {...tableProps} ref={registerChild}>
      <Column
        dataKey="date"
        label="Date"
        cellRenderer={dateRenderer}
        headerRenderer={headerRenderer}
        width={200}
        flexGrow={0}
      />
      <Column
        dataKey="name"
        label="Name"
        cellRenderer={nameRenderer}
        headerRenderer={headerRenderer}
        width={200}
        flexGrow={0}
      />
      <Column
        dataKey="productName"
        label="Product Name"
        cellRenderer={productRenderer}
        headerRenderer={headerRenderer}
        width={300}
        flexGrow={1}
      />
      <Column
        dataKey="fileType"
        label="File Type"
        headerRenderer={headerRenderer}
        width={100}
        flexGrow={0}
        className="text-uppercase"
      />
      <Column
        dataKey="fileName"
        label="File Name"
        headerRenderer={headerRenderer}
        width={300}
        flexGrow={1}
      />
    </Table>
  );
};

DownloadsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      name: PropTypes.string,
      productUrl: PropTypes.string,
      productName: PropTypes.string,
      fileType: PropTypes.string,
      fileName: PropTypes.string
    })
  ).isRequired,
  registerChild: PropTypes.any
};

DownloadsTable.defaultTypes = {
  data: []
};

export default DownloadsTable;
